type AbbreviateNumber = (num: number, mantissaLength?: number) => string;

export const abbreviateNumber: AbbreviateNumber = (num, mantissaLength = 2) => {
  // mantissaLength = 2 to show fractions to 2 decimal places
  const SI_POSTFIXES = ["", "K", "M", "B", "T", "P", "E"];
  const tier = (Math.log10(Math.abs(num)) / 3) | 0;
  if (tier <= 0) return num ? num.toFixed(mantissaLength) : "0.0";
  const postfix = SI_POSTFIXES[Math.abs(tier)];
  const scale = Math.pow(10, tier * 3);
  const scaled = num / scale;
  const mantissa = scaled > 100 ? 1 : 2;
  let formatted = scaled.toFixed(mantissa) + "";
  if (/\.0$/.test(formatted)) formatted = formatted.substr(0, formatted.length - 2);
  const result = formatted + postfix;
  return result;
};
